import axios from '../../../axios';
import { IFile } from '../../../types';

const url = 'invoicingservice/api/file';

export const saveFile = (file: IFile) => axios.post(url, file);

export const deleteFile = (id: string) => axios.delete(`${url}/${id}`);
